import React from "react";
import { SheetDetail } from "../types";

interface InspectionCardTabsProps {
  sheetDetails: SheetDetail[];
  activeTab: number;
  isDarkMode: boolean;
  onTabChange: (tabIndex: number) => void;
}

export const InspectionCardTabs: React.FC<InspectionCardTabsProps> = ({
  sheetDetails,
  activeTab,
  isDarkMode,
  onTabChange,
}) => {
  const getTabTitle = (type: string): string => {
    const titles: { [key: string]: string } = {
      PRETRIP: "PRETRIP",
      "DOT-Tractor": "DOT Tractor",
      "DOT-Trailer": "DOT Trailer",
    };
    // Replace underscores with spaces and return
    return (titles[type] || type).replace(/_/g, " ");
  };

  if (sheetDetails.length === 0) return null;

  return (
    <div className={`border-b ${isDarkMode ? "bg-gray-700" : "bg-gray-100"}`}>
      <div className="flex">
        {sheetDetails.map((sheet, tabIndex) => (
          <button
            key={sheet.id}
            onClick={() => onTabChange(tabIndex)}
            className={`flex-1 py-2.5 px-2 text-sm font-semibold transition-colors ${
              activeTab === tabIndex
                ? isDarkMode
                  ? "bg-gray-800 text-phoenix-400 border-b-2 border-phoenix-500"
                  : "bg-white text-phoenix-600 border-b-2 border-phoenix-600"
                : isDarkMode
                ? "bg-gray-600 text-gray-300 hover:bg-gray-500"
                : "bg-phoenix-50 text-phoenix-800 hover:bg-phoenix-100"
            }`}
          >
            <div className="truncate text-xs">
              {getTabTitle(sheet.template_name)}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
